export default function threatScoreDirective() {
  return {
    template: require('./threat-score.html'),
    scope: {
      selectedOptionId: '=',
      selectedOptionValue: '=',
      options: '<',
      optionIdFieldName: '@',
    },
    controller: () => { /* 'threatScoreController' */ },
    controllerAs: 'threatScoreVM',
    bindToController: true,
    replace: true,
    link(scope, el, attrs) { // eslint-disable-line no-unused-vars
      // Load threatType id and value into selectedOption viewmodel
      scope.selectedOption = scope.threatScoreVM.options.find(
        item => item[scope.threatScoreVM.optionIdFieldName] === scope.threatScoreVM.selectedOptionId
      );

      scope.onChangeHandler = () => {
        scope.threatScoreVM.selectedOptionId = scope.selectedOption[scope.threatScoreVM.optionIdFieldName];
        scope.threatScoreVM.selectedOptionValue = scope.selectedOption.value;
      };
    }
  };
}
